import Joi from "joi";

import {constantsRegex} from "../constants/constants.regex";

export const regularCustomerValidator = Joi.object({
    email: Joi.string().pattern(constantsRegex.EMAIL).required().messages({
        'string.empty': 'Заповніть це поле',
        'string.pattern.base': 'Невалідний email',
    }),
    password: Joi.string().required().min(8).messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів'
    }),
});
